import { useEffect } from "react";
import emailjs from "emailjs-com";

export default function useVisitorAlert() {
  useEffect(() => {
    // prevent multiple emails per session
    if (sessionStorage.getItem("visitorAlertSent")) return;

    const sendAlert = async () => {
      try {
        await emailjs.send(
          process.env.REACT_APP_EMAILJS_SERVICE_ID_VISITOR,
          process.env.REACT_APP_EMAILJS_VISITOR_TEMPLATE_ID__VISITOR,
          {
            time: new Date().toLocaleString(),
            user_agent: navigator.userAgent,
          },
          process.env.REACT_APP_EMAILJS_PUBLIC_KEY
        );

        sessionStorage.setItem("visitorAlertSent", "true");
        console.log("Visitor alert sent");
      } catch (error) {
        console.error("Visitor alert failed:", error);
      }
    };

    sendAlert();
  }, []);
}
